module.exports = __webpack_public_path__ + "img/scissors.4c00afc0.png";